import { LayoutService } from './layout.service';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import {
  BUSINESS_DETAIL_QUERY,
  GET_URLS_IMAGE_SLIDER,
} from '../queries/business.queries';
import { BehaviorSubject, Subject, distinctUntilChanged } from 'rxjs';
import {
  BusinessAttributes,
  BusinessInput,
  BusinessValues,
} from '../models/businessInput.model';
import { StorageService } from './storage.service';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';
import { PaymentGatewaysService } from './payment-gateways.service';
import { LocalstorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  private businessSubject = new BehaviorSubject<BusinessInput | null>(null);

  business!: BusinessInput | null;
  constructor(
    private apollo: Apollo,
    private storageService: StorageService,
    private paymentGatewayService: PaymentGatewaysService,
    private layoutService: LayoutService
  ) {
    // this.businessSubject = new BehaviorSubject<BusinessInput>(null);
  }

  getBusinessDetail() {
    let businessValues = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    );
    return this.apollo
      .watchQuery({
        query: BUSINESS_DETAIL_QUERY,
        variables: {
          businessId: businessValues.businessId,
          merchantId: businessValues.merchantId,
        },
      })
      .valueChanges.subscribe((result: any) => {
        if (result.data.GetBusinessById) {
            this.paymentGatewayService.getPaymentGateway();
          this.businessSubject.next(result.data.GetBusinessById);
          this.storageService.setLocalStorageData(
            LOCAL_STORAGE.BUSINESS_DETAILS,
            JSON.stringify(result.data.GetBusinessById)
          );
          this.storageService.setLocalStorageData(
            LOCAL_STORAGE.VERTICAL,
            result.data.GetBusinessById.vertical.toUpperCase()
          );
          // LocalStorageService.setValue(
          //   LOCAL_STORAGE.VERTICAL,
          //   result.data.GetBusinessById.vertical.toUpperCase()
          // );
          this.setApplicationTheme(
          	result.data.GetBusinessById.businessAttributes.theme,
          );
        }
      });
  }
  setApplicationTheme(theme: string) {
		console.log("theme", theme);
		this.storageService.setLocalStorageData(LOCAL_STORAGE.THEME, theme);
		this.layoutService.addBodyClass(theme);
	}

  getBusinessSubscription() {
    if (!this.businessSubject.value) {
      this.getBusinessDetail();
    }

    return this.businessSubject.asObservable();
  }

  getUrlsImageSlider() {
    let businessValues = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    );
    console.log(businessValues);
    return this.apollo.watchQuery({
      query: GET_URLS_IMAGE_SLIDER,
      variables: {
        id: businessValues.businessId,
      },
    });
  }

  // getBusinessDetails() {
  //   return this.apollo
  //     .watchQuery({
  //       query: BUSINESS_DETAIL_QUERY,
  //       variables: {
  //         businessId: LocalStorageService.getValue(LOCAL_STORAGE.BUSINESSID),
  //         merchantId: LocalStorageService.getValue(LOCAL_STORAGE.MERCHANT_ID),
  //       },
  //     })
  //     .valueChanges.subscribe((result: any) => {
  //       console.log('payment-gateways', result.data.GetBusinessById);
  //       if (result.data.GetBusinessById) {
  //         if (result.data.GetBusinessById) {
  //           this.paymentGatewayService.getPaymentGateway();
  //         }
  //         this.business.next(result.data.GetBusinessById);

  //         LocalStorageService.setValue(
  //           LOCAL_STORAGE.VERTICAL,
  //           result.data.GetBusinessById.vertical.toUpperCase()
  //         );
  //         this.setApplicationTheme(
  //           this.business.value.businessAttributes.theme
  //         );
  //       }
  //     });
  // }

  getBusinessValue() {
		return this.businessSubject.value;
	}
}
